import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProducts } from '../contexts/ProductContext';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { FaArrowLeft, FaMinus, FaPlus } from 'react-icons/fa';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getProductById } = useProducts();
  const { addToCart, getCartItem } = useCart();
  const { user } = useAuth();
  
  const [quantity, setQuantity] = useState(1);
  
  const product = getProductById(id);
  const cartItem = getCartItem(id);

  if (!user) {
    return (
      <div className="container text-center mt-5">
        <h2>Please login to view product details</h2>
        <button onClick={() => navigate('/login')} className="btn btn-primary">
          Login
        </button>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="container text-center mt-5">
        <h2>Product not found</h2>
        <button onClick={() => navigate('/products')} className="btn btn-primary">
          Back to Products
        </button>
      </div>
    );
  }

  const handleQuantityChange = (newQuantity) => {
    if (newQuantity >= 1) {
      setQuantity(newQuantity);
    }
  };

  const handleAddToCart = () => {
    addToCart(product, quantity);
    setQuantity(1);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={product.image}
            alt={product.name}
            className="img-fluid rounded"
            style={{ width: '100%', height: '400px', objectFit: 'cover' }}
          />
        </div>
        
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <button
                onClick={() => navigate('/products')}
                className="btn btn-outline-secondary mb-3"
              >
                <FaArrowLeft /> Back to Products
              </button>
              
              <h2 className="card-title">{product.name}</h2>
              <p className="text-muted mb-3">{product.category}</p>
                              <h3 className="text-primary mb-3">₹{product.price}</h3>
              
              <p className="card-text mb-4">{product.description}</p>
              
              {cartItem && (
                <div className="alert alert-info mb-3">
                  <strong>{cartItem.quantity}</strong> item(s) in cart
                </div>
              )}
              
              <div className="mb-4">
                <label className="form-label">Quantity:</label>
                <div className="d-flex align-items-center gap-3">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => handleQuantityChange(quantity - 1)}
                    disabled={quantity <= 1}
                  >
                    <FaMinus />
                  </button>
                  <span className="h5 mb-0" style={{ minWidth: '50px', textAlign: 'center' }}>
                    {quantity}
                  </span>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => handleQuantityChange(quantity + 1)}
                  >
                    <FaPlus />
                  </button>
                </div>
              </div>
              
              <div className="d-grid gap-2">
                <button
                  onClick={handleAddToCart}
                  className="btn btn-primary btn-lg"
                >
                  Add to Cart - ₹{(product.price * quantity).toFixed(2)}
                </button>
                
                <button
                  onClick={() => navigate('/cart')}
                  className="btn btn-outline-primary"
                >
                  View Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail; 